import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage/HomePage";
import NotFound from "./components/NotFound/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import ScrollAnimations from "./components/ScrollAnimations";

// Everything except the landing page is loaded on demand, so a first-time
// visitor to "/" never downloads the other pages or the admin/CMS editor
// (Firebase Auth/Storage, TinyMCE wrapper, drag-and-drop, ...).
const AboutUsPage = lazy(() => import("./pages/AboutUsPage/AboutUsPage"));
const ServicesPage = lazy(() => import("./pages/ServicesPage/ServicesPage"));
const AchievementsPage = lazy(() =>
  import("./pages/AchievementsPage/AchievementsPage")
);
const AboutPianosPage = lazy(() =>
  import("./pages/AboutPianosPage/AboutPianosPage")
);
const ContactUsPage = lazy(() => import("./pages/ContactUsPage/ContactUsPage"));
const Admin = lazy(() => import("./components/Admin/Admin"));

// Reserves a full screen while a page chunk loads, so the footer stays below the
// fold and never visibly jumps when the page content arrives.
const PageFallback = () => (
  <div style={{ minHeight: "100vh" }} role="status" aria-label="Loading page" />
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollAnimations />
      <div className="App">
        {/* Don't show header on admin page */}
        <Routes>
          <Route path="/admin/*" element={null} />
          <Route path="*" element={<Header />} />
        </Routes>

        <main className="main-content">
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/about-pianos" element={<AboutPianosPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/achievements" element={<AchievementsPage />} />
              <Route path="/enquiry" element={<ContactUsPage />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        {/* Don't show footer on admin page */}
        <Routes>
          <Route path="/admin/*" element={null} />
          <Route path="*" element={<Footer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
